"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.footerWrapperTheme = void 0;
var deepmerge_1 = __importDefault(require("deepmerge"));
var footerWrapperTheme = function (theme) {
    var componentTheme = {
        marginTop: '3.25rem',
        color: '#444444',
        backgroundColor: '#f4f4f4',
        fontSizeMobile: '0.938rem',
        fontSizeMobileSmall: '0.813rem',
        fontSizeDesktop: '0.75rem',
        fontSizeDesktopSmall: '0.688rem',
        block: {
            headline: {
                family: theme.base.font.bold.family,
                weight: theme.base.font.bold.weight,
            },
        },
        footer: {
            maxWidth: '71.25rem',
            margin: '0 auto -1.536rem auto',
            padding: '4.25rem 0 0 0',
        },
        footerMobile: {
            margin: '3.25rem auto 0 auto',
            padding: '0',
        },
        socket: {
            fontSize: '0.68rem',
            color: '#a0a0a0 !important',
            padding: '1.536rem 0 5.25rem 0',
        },
        socketMobile: {
            fontSize: '0.813rem',
            padding: '1.536rem 2rem 4.813rem 1rem',
        },
    };
    return __assign(__assign({}, theme), { component: __assign(__assign({}, theme.component), { footer: theme.component.footer
                ? deepmerge_1.default(componentTheme, theme.component.footer)
                : componentTheme }) });
};
exports.footerWrapperTheme = footerWrapperTheme;
exports.default = exports.footerWrapperTheme;
//# sourceMappingURL=theme.js.map